import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';

export default function BlockText({ block }) {
  let title = '';
  let icon = '';
  let text = '';

  switch (block) {
    case 'block1':
      title = 'Productivity';
      icon = 'productivity-icon';
      text = 'To what extent do the following statements reflect who you are?';
      break;

    case 'block2':
      title = 'Wellbeing. Part 1';
      icon = 'wellbeing-icon';
      text = 'At work during the last month, how often did you have the following thoughts or feelings?';
      break;

    case 'block3':
      title = 'Wellbeing. Part 2';
      icon = 'wellbeing-icon';
      text = 'At work during the last month, how often did you experience the following feelings?';
      break;

    case 'block4':
      title = 'Wellbeing. Part 3';
      icon = 'wellbeing-icon';
      text = 'How would you describe your physical health?';
      break;

    case 'block5':
      title = 'Career History';
      icon = 'career-history-icon';
      text = 'Your answers will show us the special journey you\'ve made in your career. '
             + 'This helps us get to know you better and support your career growth.';
      break;

    default:
      throw Error(`Unknown block: ${block}`);
  }

  return (
    <IconWithText iconClassName={`${icon} big-icon bg-secondary-800`}>
      <div className="fw-semibold">
        {title}
      </div>

      <p>{text}</p>
    </IconWithText>
  );
}

BlockText.propTypes = {
  block: PropTypes.string.isRequired,
};
